/* eslint-disable security/detect-possible-timing-attacks */
/* eslint-disable security/detect-object-injection */
import { AnimatePresence } from 'framer-motion';
import React, { useEffect, useRef, useState } from 'react';
import AnimatedPageFade from '../components/Animations/AnimatedPageFade';
import ApplicationContext from '../context/ApplicationContext';
import { Route, Routes } from 'react-router-dom';
import Layout from '../components/Layout';
import Loading from './Loading';
import { dataService } from '../services/data.service';
import PageNotFound from './PageNotFound';
import Main from '../pages/Main';
import { decryptMessage } from '../helpers/CommonFunctions';
import { sessionKey } from '../config';

function NavigationRoutes() {
    const [loading, setLoading] = useState(true);
    const [facilityData, setFacilityData] = useState(null);
    const [validLink, setValidLink] = useState(false);
    const [currentPage, setCurrentPage] = useState('');
    const [currentAppointment, setCurrentAppointment] = useState('');
    const [idCardData, setIdCardData] = useState('');
    const [sessionData, setSessionData] = useState('');
    const [insuranceData, setInsuranceData] = useState('');
    const [ocrInsuranceFrontData, setOcrInsuranceFrontData] = useState('');
    const [ocrInsuranceBackData, setOcrInsuranceBackData] = useState('');
    const [insurances, setInsurances] = useState([]);
    const [insuranceIndex, setInsuranceIndex] = useState('');
    const [insurancePreference, setInsurancePreference] = useState('');
    const [backLoader, setBackLoader] = useState(false);
    const [selectedLanguage, setSelectedLanguage] = useState('en');
    const [selectedLanguageName, setSelectedLanguageName] = useState('english');
    const [signatureForms, setSignatureForms] = useState([]);
    const [tempToken, setTempToken] = useState('');
    const [mergeFieldValues, setMergeFieldValues] = useState({});
    const [signatureState, setSignatureState] = useState({
        signature_value: '',
        signature_type: '',
        selected_font: '',
        selected_font_class: '',
        user_name: '',
        user_initials: ''
    });

    const getCurrentSession = () => {
        dataService.getCurrentSessionData().then((res) => {
            if(res.error === false) {
                let data = decryptMessage(res.data.session, sessionKey);
                let parsedData = JSON.parse(data)
                setSessionData(parsedData);
                let tempurl = '';
                Object.keys(parsedData).forEach((key) => {
                    if(key === 'choose_language' && parsedData[key].includes('true')) {
                        setCurrentPage('choose_language');
                        setLoading(false);
                        setBackLoader(false);
                        tempurl = (parsedData.choose_language).split('-')[1]
                        return;
                    }
                    if(parsedData['insurance_index'] !== "false" && parsedData['insurance_index'] !== undefined) {
                        let index = parsedData['insurance_index'].split(' ');
                        setInsuranceIndex(parseInt(index));
                    }
                    if(parsedData[key] === "true" && key !== 'upload_id_photo') {
                        tempurl = key;
                        setCurrentPage(key);
                        if(!key.includes('insurance')) {
                            setLoading(false);
                            setBackLoader(false);
                        }
                        return;
                    }
                })
                setSelectedLanguage(parsedData.language_code);
                setSelectedLanguageName(parsedData.selected_language);
                if(tempurl === '') {
                    setLoading(false);
                    handlePage('appointments');
                    setBackLoader(false);
                }
            } else {
                setCurrentPage('welcome');
                setLoading(false);
                setBackLoader(false);
            }
        })
    }

    const updateCurrentSession = (page, prevPage, insuranceIndex, isPrevious, selectedLanguageCode, selectedLanguage, documentData, signatureData) => {
        const payload = {
            "appointments": "false",
            "appointment_options": "false",
            "identity": "false",
            "cancel": "false",
            "thankyou": "false",
            "reschedule": "false",
            "insurance": "false",
            "card_details": "false",
            "upload_id_choice": "false",
            "upload_id_image": sessionData.upload_id_image === 'completed' ? 'completed' : "false",
            "take_id_image": sessionData.take_id_image === 'completed' ? 'completed' : "false",
            "insurance_details": "false",
            "documents": "false",
            "upload_insurance_choice": "false",
            "upload_insurance_images": sessionData.upload_insurance_images === 'completed' ? 'completed' : "false",
            "take_insurance_front_image": "false",
            "take_insurance_back_image": "false",
            "insurance_index": insuranceIndex || sessionData.insurance_index || "false",
            "review": isPrevious ? 'previous' : "false",
            "selected_language": selectedLanguage || sessionData.selected_language ||  facilityData.selected_language,
            "choose_language": "false",
            "language_code": selectedLanguageCode || sessionData.language_code ||  facilityData.language_code,
            "signature": "false",
            'signature_session': sessionData.signature_session
        }
        if(page === 'choose_language') {
            payload['choose_language'] = `true-${currentPage}`
        } else {
            payload[page] = "true";
        }
        if(prevPage) {
            payload[prevPage] = 'completed';
        }
        if(insuranceIndex) {
            payload['insurance_index'] = insuranceIndex.toString();
        }
        let documentSession = sessionData.document_session;
        if(page === 'documents') {
            if(Object.keys(documentSession).length === 0) {
                documentSession = {
                    'document_index': 1,
                    'current_document_id': '',
                }
            } else {
                documentSession = {
                    'document_index': documentData.document_index,
                    'current_document_id':  documentData.current_document_id,
                }
            }
        }
        payload['document_session'] = documentSession;
        if(signatureData) {
            payload['signature_session'] =  signatureData
        }
        dataService.updateCurrentSessionData(payload).then((res) => {
            if(res.error === false) {
                getCurrentSession();
            }
        })
    }

    const getFacilityData = () => {
        const session = sessionStorage.getItem('session');
        const token = sessionStorage.getItem('token');
        let tempToken = location.search.split('=')[1];
        if(tempToken){
            tempToken = tempToken.split('&')[0];
            setTempToken(tempToken.split('&')[0]);
        }
        dataService.getFacilityData(tempToken).then((res) => {
            if(res.error === true) {
                setValidLink(false);
                setLoading(false);
                setBackLoader(false);
                sessionStorage.removeItem('session');
            } else {
                if(session) {
                    if(token === tempToken) {
                        setLoading(true);
                        getCurrentSession();
                    } else {
                        sessionStorage.removeItem('token');
                        sessionStorage.removeItem('session');
                        setCurrentPage('welcome');
                        setLoading(false);
                        setBackLoader(false);
                    }
                } else {
                    setCurrentPage('welcome');
                    setLoading(false);
                    setBackLoader(false);
                }
                setValidLink(true);
                setFacilityData(res.data);
                setSelectedLanguage(res.data.language_code);
                setSelectedLanguageName(res.data.selected_language);
                if(res.data.appointment_status === 'Cancelled' || res.data.appointment_status === 'Completed') {
                    handlePage('thankyou');
                }
            }
        })
    }

    useEffect(() => {
        getFacilityData();
    }, []);

    const handlePage = (page, prevPage, insuranceIndex, isPrevious, selectedLanguageCode, selectedLanguage, documentData, signatureData) => {
        if(page !== 'welcome' && page !== 'nameVerify' && page !== 'dobVerify') {
            setCurrentPage(page);
            updateCurrentSession(page, prevPage, insuranceIndex, isPrevious, selectedLanguageCode, selectedLanguage, documentData, signatureData);
        } else {
            setCurrentPage(page);
            if(page === 'welcome') {
                getFacilityData();
            }
        }
    }

    const handleGetInsuranceList = () => {
        dataService.getInsuranceList(sessionStorage.getItem('session')).then((res) => {
            setInsurances(res.data.data);
            setLoading(false);
            setBackLoader(false);
        })
    }

    const getInsurancePreference = () => {
        dataService.getInsurancePreference(sessionStorage.getItem('session')).then((res) => {
            if(res.error === false) {
                setInsurancePreference(res.data.data);
            }
        })
    }

    const getIdentityCardDetails = () => {
        dataService.getIDCardDetails(sessionStorage.getItem('session')).then((res) => {
            if(res.error === false) {
                setIdCardData(res.data.data);
            }
        })
    }

    const getSignatureForms = () => {
        dataService.listSignatureDocuments().then((res) => {
            setSignatureForms(res.data.data);
        })
    }

    useEffect(() => {
        if(currentPage?.includes('insurance') || currentPage === 'review') {
            handleGetInsuranceList();
            getInsurancePreference();
        }
        if(currentPage?.includes('identity') || currentPage === 'review' || currentPage === 'insurance') {
            getIdentityCardDetails();
        }
        if(currentPage === 'signature') {
            getSignatureForms();
        }
    }, [currentPage])
    return (
        <AnimatePresence>
            {!loading && validLink
                ? <AnimatedPageFade>
                    <ApplicationContext.Provider value={{loading, setLoading, facilityData, setFacilityData, currentPage, setCurrentPage, handlePage, currentAppointment, setCurrentAppointment, 
                        idCardData, setIdCardData, getCurrentSession, sessionData, setSessionData,insuranceData, setInsuranceData, ocrInsuranceFrontData, setOcrInsuranceFrontData, ocrInsuranceBackData, 
                        insuranceIndex, setInsuranceIndex, insurances, insurancePreference, setInsurancePreference, handleGetInsuranceList, backLoader, setBackLoader, getInsurancePreference, selectedLanguage, getFacilityData, selectedLanguageName, 
                        signatureForms, setSignatureForms, signatureState, setSignatureState, tempToken, mergeFieldValues, setMergeFieldValues}}>
                        <Routes>
                            <Route
                                path="*"
                                element={(
                                    loading ? <Loading/> : <PageNotFound />
                                )}
                            />
                            <Route element={
                                <Layout />}>
                                <Route path='/facility' element={<Main />} />
                            </Route>
                        </Routes>
                    </ApplicationContext.Provider>
                </AnimatedPageFade>
                :
                loading ? <Loading /> : <PageNotFound />
            }
        </AnimatePresence>
    );
}

export default NavigationRoutes;